import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
} from '@chakra-ui/styled-system'
import { asChakraVariable, themeColorSectionKeys } from '~/themes/colors/colors'
import { textStyleKeys } from '~/themes/textStyles'
import { useCustomMultiStyleConfig } from '~/utils/chakraUtils'
import { getName } from '~/utils/objectUtils'

import { sharedComponentColorKeys } from './_colors'

const { Input } = themeColorSectionKeys.defaults

const { SearchInput } = sharedComponentColorKeys

const SearchInputParts = ['container', 'input', 'icon'] as const

const helpers = createMultiStyleConfigHelpers(SearchInputParts)
export const SearchInputStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      display: 'flex',
      flex: 1,
      alignSelf: 'stretch',
    },
    input: {
      height: '2.5rem',
      borderRadius: '0.5rem',
      backgroundColor: SearchInput.Background,
      borderColor: SearchInput.Border,
      _hover: {
        backgroundColor: SearchInput.Hover.Background,
        borderColor: SearchInput.Hover.Border,
      },
      _active: {
        backgroundColor: SearchInput.Active.Background,
      },
      _focus: {
        backgroundColor: SearchInput.Focus.Background,
        borderColor: Input.Border.Focus,
        boxShadow: `${asChakraVariable(Input.BoxShadow.Focus)} 0px 4px 8px 0px`,
      },
      _placeholder: {
        textStyle: textStyleKeys.Body1,
        color: SearchInput.Placeholder.FontColor,
      },
    },
    icon: {
      boxSize: '1rem',
      cursor: 'auto',
    },
  },
})

export const useSearchInputStyles = (props?: StyleThemingProps) => {
  return useCustomMultiStyleConfig<typeof SearchInputParts>(
    getName({ SearchInputStyle }),
    props,
  )
}
